import { createAction, createPayloadAction } from 'helpers/actionsHelpers'
import { PayloadAction, SimpleAction } from 'interfaces/action'
import { Notification } from 'interfaces/notifications'

export const NOTIFICATIONS_SHOWN = 'NOTIFICATIONS_SHOWN' as const
type NotificationsShown = SimpleAction<typeof NOTIFICATIONS_SHOWN>
export const notificationsShownActionCreator = (): NotificationsShown =>
  createAction(NOTIFICATIONS_SHOWN)

export const NOTIFICATIONS_EXPAND_BUTTON_SHOWN = 'NOTIFICATIONS_EXPAND_BUTTON_SHOWN' as const
type NotificationsExpandButtonShown = SimpleAction<typeof NOTIFICATIONS_EXPAND_BUTTON_SHOWN>
export const notificationsExpandButtonShownActionCreator = (): NotificationsExpandButtonShown =>
  createAction(NOTIFICATIONS_EXPAND_BUTTON_SHOWN)

export const TOGGLE_NOTIFICATIONS_EXPANDED = 'TOGGLE_NOTIFICATIONS_EXPANDED' as const
type ToggleNotificationsExpanded = PayloadAction<typeof TOGGLE_NOTIFICATIONS_EXPANDED, { isExpanded: boolean }>
export const toggleNotificationsExpandedActionCreator = (isExpanded: boolean): ToggleNotificationsExpanded =>
  createPayloadAction(TOGGLE_NOTIFICATIONS_EXPANDED, { isExpanded })

export const ADD_NOTIFICATION = 'ADD_NOTIFICATION' as const
type AddNotification = PayloadAction<typeof ADD_NOTIFICATION, Notification>
export const addNotificationActionCreator = (notification: Notification): AddNotification =>
  createPayloadAction(ADD_NOTIFICATION, notification)

export const DISMISS_NOTIFICATION = 'DISMISS_NOTIFICATION' as const
type DismissNotification = PayloadAction<typeof DISMISS_NOTIFICATION, string>
export const dismissNotificationActionCreator = (id: string): DismissNotification =>
  createPayloadAction(DISMISS_NOTIFICATION, id)

export type NotificationActions =
  | NotificationsShown
  | NotificationsExpandButtonShown
  | ToggleNotificationsExpanded
  | AddNotification
  | DismissNotification

export default NotificationActions
